// MakerHub: labels are team-scoped by a company suffix (e.g. "follow-up-warranty-s3",
// "…-mk"). Strip that suffix for DISPLAY only — the underlying title keeps the
// suffix (used for filtering, label views, team scoping). Display-only, so
// chips read "follow-up-warranty" while the label stays "follow-up-warranty-s3".
export const displayLabelTitle = (title = '') =>
  title.replace(/-(s3|mk)$/i, '');

export default displayLabelTitle;
